import {
  useRecoilValue,
} from 'recoil';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

import { DarkGreen } from './Styles';
import { productCount } from './Order';
import basketIcon from '../containers/img/basket_icon.svg';
import { orderStartedState } from '../helpers/userState';

const CartBadge = () => {
  const orderStarted = useRecoilValue(orderStartedState);
  const itemCount = orderStarted ? productCount(orderStarted) : 0;
  if (itemCount === 0) {
    return <div css={{ flex: '0 0 3rem' }} />;
  }
  return (
    <Link
      to="/orders"
      css={{
        marginRight: '12px',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
      }}
    >
      <Avatar
        src={basketIcon}
        css={{ height: '24px', width: '24px' }}
      />
      <Typography
        css={{ margin: 0, fontSize: '0.8rem', color: `${DarkGreen}` }}
      >
        {itemCount} item{itemCount !== 1 ? 's' : ''}
      </Typography>
    </Link>
  );
};

export default CartBadge;
